import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Paper,
  Button,
  useTheme,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Alert,
  Snackbar,
  InputAdornment
} from "@mui/material";
import {
  Print as PrintIcon,
  Business as BusinessIcon,
  Search as SearchIcon
} from "@mui/icons-material";
import api from "../../services/api";
import AcessoRestrito from '../../components/AcessoRestrito';
import env from '../../config/env';

// Removido drawerWidth - não utilizado neste módulo 

export default function RelatorioEmpresas() {
  const theme = useTheme();
  const usuario = JSON.parse(localStorage.getItem("usuario"));
  const st_codHashEmpresaLocal = localStorage.getItem("st_codHashEmpresa");

  const isSuperuserEmpresa1 =
    usuario?.perfil === "superusuario" &&
    st_codHashEmpresaLocal ===
      "412F2F6A9477DB7E04B3098C0B0FFBEB3FF7F9054ABD0CDBC5A3EF3F8E31C574";

  const [empresas, setEmpresas] = useState([]);
  const [empresaModulo, setEmpresaModulo] = useState([]);
  const [modulos, setModulos] = useState([]);
  const [buscaEmpresa, setBuscaEmpresa] = useState("");
  const [buscaModulo, setBuscaModulo] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isSuperuserEmpresa1) return;

    const carregarDados = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const [empresasRes, empresaModuloRes, modulosRes] = await Promise.all([
          api.get("/empresas"),
          api.get("/empresamodulo"),
          api.get("/modulos")
        ]);

        setEmpresas(
          empresasRes.data.sort((a, b) => a.st_nome.localeCompare(b.st_nome))
        );
        setEmpresaModulo(empresaModuloRes.data);
        setModulos(modulosRes.data);
      } catch (err) {
        setError("Erro ao carregar dados. Por favor, tente novamente.");
        console.error("Erro ao carregar dados:", err);
      } finally {
        setLoading(false);
      }
    };

    carregarDados();
  }, [isSuperuserEmpresa1]);

  const empresasFiltradas = empresas
    .map((empresa) => {
      const modulosDaEmpresa = empresaModulo
        .filter((em) => em.id_empresa === empresa.id_empresa)
        .map((em) => modulos.find((modulo) => modulo.id_modulo === em.id_modulo))
        .filter((modulo) => modulo);

      const subtotal = modulosDaEmpresa.reduce((acc, curr) => {
        return acc + parseFloat(curr.vl_precoMensal || 0);
      }, 0);

      return { ...empresa, modulosDaEmpresa, subtotal };
    })
    .filter((empresa) => empresa.subtotal > 0)
    .filter((empresa) =>
      empresa.st_nome.toLowerCase().includes(buscaEmpresa.toLowerCase()) &&
      empresa.modulosDaEmpresa.some(modulo => 
        modulo.st_descricao.toLowerCase().includes(buscaModulo.toLowerCase())
      )
    );

  const totalGeral = empresasFiltradas.reduce((acc, empresa) => acc + empresa.subtotal, 0);

  const gerarPDF = () => {
    const novaJanela = window.open("", "_blank", "width=1000,height=400,scrollbars=yes");
    const isDarkMode = theme.palette.mode === 'dark';

    if (!novaJanela) {
      alert("Não foi possível abrir a nova janela.");
      return;
    }

    const style = `
      <style>
        body {
          font-family: Arial, sans-serif;
          margin: 30px;
          background-color: ${isDarkMode ? '#121212' : '#ffffff'};
          color: ${isDarkMode ? '#ffffff' : '#000000'};
        }
        h1 {
          text-align: center;
          color: ${isDarkMode ? '#90caf9' : '#1976d2'};
        }
        table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 20px;
        }
        th, td {
          padding: 10px;
          text-align: left;
          border: 1px solid ${isDarkMode ? '#424242' : '#e0e0e0'};
        }
        th {
          background-color: ${isDarkMode ? '#1e1e1e' : '#f5f5f5'};
          color: ${isDarkMode ? '#90caf9' : '#1976d2'};
        }
        tr:nth-child(even) {
          background-color: ${isDarkMode ? '#1e1e1e' : '#f5f5f5'};
        }
        tr:nth-child(odd) {
          background-color: ${isDarkMode ? '#121212' : '#ffffff'};
        }
        .empresa {
          margin-top: 30px;
          font-size: 18px;
          font-weight: bold;
          color: ${isDarkMode ? '#90caf9' : '#1976d2'};
        }
        .subtotal {
          text-align: right;
          font-weight: bold;
          margin-top: 5px;
          color: ${isDarkMode ? '#90caf9' : '#1976d2'};
        }
        .totalgeral {
          font-size: 22px;
          font-weight: bold;
          margin-top: 40px;
          text-align: right;
          color: ${isDarkMode ? '#90caf9' : '#1976d2'};
        }
        .botoes {
          margin-top: 30px;
          text-align: center;
        }
        button {
          background-color: ${isDarkMode ? '#1976d2' : '#1976d2'};
          color: white;
          padding: 10px 20px;
          margin: 5px;
          border: none;
          border-radius: 5px;
          font-size: 16px;
          cursor: pointer;
          width: 200px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }
        button:hover {
          background-color: ${isDarkMode ? '#1565c0' : '#1565c0'};
        }
        hr {
          border-color: ${isDarkMode ? '#424242' : '#e0e0e0'};
        }
        .material-icons {
          color: white;
        }
      </style>
    `;

    let conteudo = `
      <html>
      <head>
        <title>Relatório de Empresas</title>
        ${style}
        <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
      </head>
      <body>
        <h1>Relatório de Empresas e Módulos</h1>
    `;

    empresasFiltradas.forEach((empresa) => {
      conteudo += `
        <div class="empresa">${empresa.st_nome}</div>
        <table>
          <thead>
            <tr>
              <th>Descrição do Módulo</th>
              <th style="text-align:right;">Valor (R$)</th>
            </tr>
          </thead>
          <tbody>
      `;
      empresa.modulosDaEmpresa.forEach((modulo) => {
        conteudo += `
          <tr>
            <td>${modulo.st_descricao}</td>
            <td style="text-align:right;">${parseFloat(modulo.vl_precoMensal).toFixed(2)}</td>
          </tr>
        `;
      });
      conteudo += `
          </tbody>
        </table>
        <div class="subtotal">Subtotal: R$ ${empresa.subtotal.toFixed(2)}</div>
        <hr/>
      `;
    });

    conteudo += `
      <div class="totalgeral">TOTAL GERAL: R$ ${totalGeral.toFixed(2)}</div>

      <div class="botoes">
        <button onclick="window.print()">
          <span class="material-icons">print</span>
          Imprimir
        </button>
        <button onclick="window.close()">
          <span class="material-icons">close</span>
          Sair
        </button>
      </div>
    `;

    conteudo += `
      </body>
      </html>
    `;

    novaJanela.document.write(conteudo);
    novaJanela.document.close();
  };

  if (!isSuperuserEmpresa1) {
    return <AcessoRestrito />;
  }

  return (
    <AcessoRestrito modulo="relatorioempresas">
      <Box
        sx={{
          height: '100%',
          width: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
      <Snackbar 
        open={!!error} 
        autoHideDuration={env.NOTIFICATION_DURATION || 6000} 
        onClose={() => setError(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setError(null)} severity="error" sx={{ width: '100%' }}>
          {error}
        </Alert>
      </Snackbar>

      {/* Box interno com margens de 1,5% */}
      <Box sx={{
        margin: '0 1.5% 1.5% 1.5%',  // 1,5% nas laterais e inferior
        height: '90vh',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <Box sx={{ 
          p: { xs: 2, sm: 3 }, 
          pb: 2,
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: { xs: 'flex-start', sm: 'center' },
          flexDirection: { xs: 'column', sm: 'row' },
          gap: { xs: 2, sm: 0 }
        }}>
          <Typography 
            variant="h5" 
            mb={1} 
            sx={{ 
              fontSize: { xs: '1.5rem', sm: '2rem' },
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }}
          >
            <BusinessIcon sx={{ 
              fontSize: { xs: '1.5rem', sm: '2rem' },
              color: '#FFC107' // Mesma cor usada no menu lateral
            }} />
            Relatório de Empresas
          </Typography>
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            <TextField
              label="Buscar Empresa"
              size="small"
              value={buscaEmpresa}
              onChange={(e) => setBuscaEmpresa(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              sx={{ minWidth: 200 }}
            />
            <TextField
              label="Buscar Módulo"
              size="small"
              value={buscaModulo}
              onChange={(e) => setBuscaModulo(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              sx={{ minWidth: 200 }}
            />
          </Box>
        </Box>

        {/* Container da Tabela */}
        <TableContainer 
          component={Paper} 
          sx={{ 
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            overflow: 'auto',
            height: {
              xs: 'calc(90vh - 140px)',  // Mobile: mais espaço para header
              sm: 'calc(90vh - 120px)',  // Tablet: espaço padrão
              md: 'calc(90vh - 120px)',  // Desktop: espaço padrão
              lg: 'calc(90vh - 120px)'   // Large: espaço padrão
            },
            maxHeight: {
              xs: 'calc(90vh - 140px)',
              sm: 'calc(90vh - 120px)',
              md: 'calc(90vh - 120px)',
              lg: 'calc(90vh - 120px)'
            },
            width: '100%',
            minWidth: { xs: '100%', sm: '600px' },
            maxWidth: '100%',
            boxShadow: (theme) => theme.palette.mode === 'dark' 
              ? '0 2px 8px rgba(0, 0, 0, 0.15)' 
              : '0 2px 8px rgba(0, 0, 0, 0.06)',
            borderRadius: 2,
            border: 'none'
          }}
        >
          {loading && (
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                zIndex: 1
              }}
            >
              <CircularProgress />
            </Box>
          )}
          
          <Table sx={{ 
            minWidth: { xs: 800, sm: 650 }, 
            tableLayout: 'fixed',
            width: '100%'
          }}>
            <TableHead sx={{
              position: 'sticky',
              top: 0,
              zIndex: 10,
              backgroundColor: (theme) => theme.palette.background.paper,
              '& .MuiTableCell-root': {
                backgroundColor: (theme) => theme.palette.background.paper,
                borderBottom: 2,
                borderBottomColor: 'divider'
              }
            }}>
              <TableRow>
                <TableCell sx={{ 
                  width: { xs: '25%', sm: '20%' },
                  fontWeight: 600,
                  fontSize: '0.875rem'
                }}>
                  Empresa
                </TableCell>
                <TableCell sx={{ 
                  width: { xs: '30%', sm: '35%' },
                  fontWeight: 600,
                  fontSize: '0.875rem'
                }}>
                  Módulo
                </TableCell>
                <TableCell sx={{ 
                  width: { xs: '20%', sm: '20%' },
                  fontWeight: 600,
                  fontSize: '0.875rem'
                }}>
                  Valor
                </TableCell>
                <TableCell sx={{ 
                  width: { xs: '25%', sm: '25%' },
                  fontWeight: 600,
                  fontSize: '0.875rem'
                }}>
                  Total Empresa
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {empresasFiltradas.map((empresa) => (
                <React.Fragment key={empresa.id_empresa}>
                  {empresa.modulosDaEmpresa
                    .filter(modulo => 
                      modulo.st_descricao.toLowerCase().includes(buscaModulo.toLowerCase())
                    )
                    .map((modulo, index) => (
                      <TableRow 
                        key={`${empresa.id_empresa}-${modulo.id_modulo}`}
                        sx={{
                          '&:nth-of-type(odd)': {
                            backgroundColor: (theme) => theme.palette.mode === 'dark' 
                              ? 'rgba(255, 255, 255, 0.02)' 
                              : 'rgba(0, 0, 0, 0.02)'
                          },
                          '&:hover': {
                            backgroundColor: (theme) => theme.palette.mode === 'dark' 
                              ? 'rgba(255, 255, 255, 0.08)' 
                              : 'rgba(0, 0, 0, 0.04)'
                          }
                        }}
                      >
                        {index === 0 && (
                          <TableCell 
                            rowSpan={empresa.modulosDaEmpresa.filter(m => 
                              m.st_descricao.toLowerCase().includes(buscaModulo.toLowerCase())
                            ).length}
                            sx={{ 
                              overflow: 'hidden', 
                              textOverflow: 'ellipsis', 
                              whiteSpace: 'nowrap',
                              height: '40px',
                              padding: '8px 16px',
                              verticalAlign: 'middle'
                            }}
                          >
                            {empresa.st_nome}
                          </TableCell>
                        )}
                        <TableCell sx={{ 
                          overflow: 'hidden', 
                          textOverflow: 'ellipsis', 
                          whiteSpace: 'nowrap',
                          height: '40px',
                          padding: '8px 16px',
                          verticalAlign: 'middle'
                        }}>
                          {modulo.st_descricao}
                        </TableCell>
                        <TableCell sx={{ 
                          overflow: 'hidden', 
                          textOverflow: 'ellipsis', 
                          whiteSpace: 'nowrap',
                          height: '40px',
                          padding: '8px 16px',
                          verticalAlign: 'middle'
                        }}>
                          R$ {parseFloat(modulo.vl_precoMensal).toFixed(2)}
                        </TableCell>
                        {index === 0 && (
                          <TableCell 
                            rowSpan={empresa.modulosDaEmpresa.filter(m => 
                              m.st_descricao.toLowerCase().includes(buscaModulo.toLowerCase())
                            ).length}
                            sx={{ 
                              overflow: 'hidden', 
                              textOverflow: 'ellipsis', 
                              whiteSpace: 'nowrap',
                              height: '40px',
                              padding: '8px 16px',
                              verticalAlign: 'middle',
                              fontWeight: 600
                            }}
                          >
                            R$ {empresa.subtotal.toFixed(2)}
                          </TableCell>
                        )}
                      </TableRow>
                    ))}
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Rodapé com Resumo e Botão de Imprimir */}
        <Box sx={{ 
          p: 2, 
          borderTop: 1, 
          borderColor: 'divider',
          backgroundColor: (theme) => theme.palette.background.paper,
          position: 'sticky',
          bottom: 0,
          zIndex: 1
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6">
              Total Geral: R$ {totalGeral.toFixed(2)}
            </Typography>
            <Button
              variant="contained"
              startIcon={<PrintIcon />}
              onClick={gerarPDF}
              disabled={loading}
              sx={{ 
                width: { xs: '100%', sm: 'auto' },
                minWidth: { xs: 'auto', sm: '200px' },
                backgroundColor: (theme) => theme.palette.mode === 'dark' 
                  ? '#ffffff' 
                  : theme.palette.primary.main,
                color: (theme) => theme.palette.mode === 'dark' 
                  ? '#000000' 
                  : theme.palette.primary.contrastText,
                '&:hover': {
                  backgroundColor: (theme) => theme.palette.mode === 'dark' 
                    ? '#f5f5f5' 
                    : theme.palette.primary.dark,
                }
              }}
            >
              Imprimir Relatório
            </Button>
          </Box>
        </Box>
      </Box> {/* Fechamento do Box interno com margens */}
    </Box>
    </AcessoRestrito>
  );
}
